<template>
  <div v-b-tooltip.hover :title="tooltip[hook]">
    <!-- buffCommand -->
    <b-form-select v-model="innerValue.args.buffCommand"
      :options="buffList"
      class="buff" />
    <!-- buffColor -->
    <b-form-select v-model="innerValue.args.buffColor" 
      :options="[
        { value:null, text:'-' },
        { value:'a', text:'灰' },
        { value:'r', text:'赤' },
        { value:'b', text:'青' },
        { value:'y', text:'黄' },
        { value:'s', text:'茶' },
        { value:'g', text:'緑' },
        { value:'w', text:'白' },
        { value:'d', text:'黒' },
        { value:'n', text:'無' }
      ]"
      class="buff" />
    <b-form-select v-model="innerValue.args.buffType" 
      :options="[
        { value:null, text:'-' },
        { value:'buff-magic', text:'強化魔法' },
        { value:'debuff-magic', text:'弱体魔法' },
        { value:'buff-stance', text:'強化体勢' },
        { value:'debuff-stance', text:'弱体体勢' },
        { value:'buff-physical', text:'強化肉体' },
        { value:'debuff-physical', text:'弱体肉体' },
        { value:'buff-mental', text:'強化精神' },
        { value:'debuff-mental', text:'弱体精神' },
        { value:'debuff-cooltime', text:'CT' },
      ]" 
      class="buff" />
    のバフが付与
    <b-button variant="danger" size="sm"
      @click="$emit('remove')">
      <b-icon icon="x" />
    </b-button>
  </div>
</template>

<script>
import _ from 'lodash'
import Hook from './Hook'
export default {
  extends: Hook,
  props: {
    info: Object
  },
  computed: {
    buffList () {
      let list = [{ value:null, text:'-' }]
      this.info.card.forEach((v)=>{
        let e = _.find(v, { '@method':'info', args:{type:'buff'} })
        if(e){
          let i = _.find(v, { '@method':'init' })
          list.push({
            value: i.args.key,
            text: e.args.name,
          })
        }
      })
      return list
    }
  },
}
</script>

<style lang="scss" scoped>
.action {
  display: inline-block;
  width: 200px;
}
.length {
  display: inline-flex;
  width: 100px;
}
.buff {
  display: inline-block;
  width: 75px;
}
</style>